const entrega_material_escolar_por_turma = [
  {
    path: "/entrega-material-escolar-por-turma",
    redirect: "/entrega_material_escolar_por_turma",
    meta: {
      breadCrumb: "Gestão - Material Escolar",
    },
    children: [
      {
        path: "/entrega-material-escolar-por-turma",
        name: "entrega_material_escolar_por_turma",
        component: () =>
          import(
            "@/views/EntregaMaterialEscolarPorTurma/EntregaMaterialEscolarPorTurma.vue"
          ),
      },
      {
        path: "/entrega-material-escolar-por-turma-novo/:ano_matricula/:turma_id/:material_id",
        name: "entrega_material_escolar_por_turma_novo",
        component: () =>
          import(
            "@/views/EntregaMaterialEscolarPorTurma/EntregaMaterialEscolarPorTurmaCad.vue"
          ),
      },
    ],
  },
];

export { entrega_material_escolar_por_turma };
